import isDraftFilterAllowedAtLocation from "./../drafts/disabledPages";
import {
  attributesToQueryString,
  parseAttributeString,
} from "./index";
import {
  addAttributes,
  createAttributesFromString,
  statusForEachPeriod,
} from "./attributes";
/**
 * This function will add the status parameters to the arguments part of tht MEA Query.
 *
 * For example if we have a query where values are asked from one or more periods
 *
 * value(series="TAR", as="tar_1", period="2012"),unit(series="TAR", as="tar_unit", period="2021")
 *
 * Then we have to add also the status queries for each of the periods where we just asked data
 * - value(series="STATUS", period="2012")
 * - value(series="STATUS", period="2021")
 *
 * The Function will return "newSet" TParserAttributes object which can be used to examine the query results
 *
 * It will also return the "newQueryAttrs" which is the string value of new attributes string which can be
 * used in queries which accept string parameters.
 *
 * It will also return "disableFilter" boolean indicating whether or not draft values filtering should be disabled
 * for this query or not.
 *
 * @param attributes
 * @returns
 */
const augmentQueryArguments = (attributes: string) => {
  // inject status values to each asked period
  const parsedAttributes = parseAttributeString(attributes);
  const disableFilter = !isDraftFilterAllowedAtLocation();
  const statuses = statusForEachPeriod(parsedAttributes);
  const newSet = addAttributes(parsedAttributes, [
    ...statuses,
    ...createAttributesFromString("typename"),
  ]);
  const newQueryAttrs = attributesToQueryString(newSet);
  return {
    newQueryAttrs,
    disableFilter,
    newSet,
  };
};
export default augmentQueryArguments;
